/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { RoleEnum } from 'app/core/roles/role.types';

const isNotAdministrator = (): boolean =>
    !AuthUtils.getTokenRoles(localStorage.getItem('accessToken') ?? '').includes(RoleEnum.Role.Administrator);

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'insights',
        title   : 'Insights',
        type    : 'group',
        children: [
            {
                id   : 'dashboard',
                title: 'Dashboard',
                type : 'basic',
                icon : 'mat_outline:dashboard',
                link : '/dashboard'
            },
            {
                id   : 'supplier-reports',
                title: 'Supplier Report',
                type : 'basic',
                icon : 'mat_outline:assessment',
                link : '/supplier-reports'
            },
        ],
    },
    {
        id      : 'operations',
        title   : 'Operations',
        type    : 'group',
        children: [
            {
                id   : 'events',
                title: 'Events',
                type : 'basic',
                icon : 'mat_outline:event',
                link : '/events'
            },
            {
                id   : 'exhibitors',
                title: 'Exhibitors',
                type : 'basic',
                icon : 'mat_outline:storefront',
                link : '/exhibitors'
            },
            {
                id   : 'sales-people',
                title: 'Sales People',
                type : 'basic',
                icon : 'mat_outline:support_agent',
                link : '/sales-people'
            },
            {
                id   : 'packages',
                title: 'Packages',
                type : 'basic',
                icon : 'mat_outline:inventory_2',
                link : '/packages'
            },
        ],
    },
    {
        id      : 'catalogue',
        title   : 'Catalogue',
        type    : 'group',
        children: [
            {
                id   : 'products',
                title: 'Products',
                type : 'basic',
                icon : 'mat_outline:category',
                link : '/products'
            },
            {
                id   : 'product-categories',
                title: 'Product Categories',
                type : 'basic',
                icon : 'mat_outline:label',
                link : '/product-categories'
            },
            {
                id   : 'suppliers',
                title: 'Suppliers',
                type : 'basic',
                icon : 'mat_outline:local_shipping',
                link : '/suppliers'
            },
            {
                id   : 'price-config',
                title: 'Price Config',
                type : 'basic',
                icon : 'mat_outline:attach_money',
                link : '/price-config'
            },
        ],
    },
    {
        id      : 'administration',
        title   : 'Administration',
        type    : 'group',
        hidden  : () => isNotAdministrator(),
        children: [
            {
                id    : 'users',
                title : 'Users',
                type  : 'basic',
                icon  : 'mat_outline:people',
                link  : '/users',
                hidden: () => isNotAdministrator(),
            },
        ],
    },
];

/**
 * The compact/futuristic/horizontal layouts render a flat list of items rather than
 * grouped sections, so flatten the grouped default navigation for them. Deriving these
 * from `defaultNavigation` keeps them from drifting out of sync — previously they were
 * maintained as separate literals and the compact one had silently lost Events,
 * Supplier Report and Suppliers.
 */
const flattenNavigation = (items: FuseNavigationItem[]): FuseNavigationItem[] =>
    items.flatMap(item =>
        item.type === 'group' || item.type === 'collapsable'
            ? flattenNavigation(item.children ?? [])
            : [item]
    );

export const compactNavigation: FuseNavigationItem[] = flattenNavigation(defaultNavigation);
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
